const step_up = {
    verify_your_identity: 'Kimliğinizi doğrulayın',
    choose_method_description: 'Devam etmek için aşağıdaki yöntemlerden biriyle siz olduğunuzu doğrulayın.',
    password: 'Şifre',
    password_description: 'Hesap şifrenizi girin',
    enter_password_description: 'Devam etmek için hesap şifrenizi girin.',
    enter_verification_code_description: '{{identifier}} adresine gönderilen doğrulama kodunu girin.',
    subject_proof_description: 'Devam etmek için hesabınıza bağlı bir hesap üzerinden siz olduğunuzu doğrulayın. Ardından bir doğrulama yöntemi ayarlayabilirsiniz.',
    subject_mismatch: 'Hesap eşleşmiyor',
    subject_mismatch_description: 'Kullandığınız hesap, hesabınıza bağlı değil. Bağlı bir hesap kullanın ve gerekirse sağlayıcıda hesap değiştirin.',
    no_method_available: 'Kullanılabilir doğrulama yöntemi yok',
    no_method_available_description: 'Hesabınızda bu doğrulamayı tamamlayabilecek bir yöntem yok. Yardım için lütfen yöneticinizle iletişime geçin.',
};
export default Object.freeze(step_up);
